export default "dist/images/block-columns-grid.00c290c.png";